import Grid from '@precis-digital/kurama/Grid'
import { styled } from '@precis-digital/kurama/utils'
import { TooltipBody, TooltipTitle } from '@precis-digital/kurama/Tooltip'
import { type ReactElement, type JSX } from 'react'

interface Data {
  x: string
  [key: string]: number | string
}

interface ChartToolTipProps {
  value: string
  payload: Data
  header: string
  customBody?: never
  title?: never
  width?: string
  maxWidth?: string
}

interface ChartToolTipPropsWithBody {
  value?: never
  payload?: never
  header?: never
  customBody: JSX.Element
  title: string
  width?: string
  maxWidth?: string
}

export const ChartToolTip = ({
  value,
  payload,
  header,
  customBody,
  title,
  width = '326px',
  maxWidth
}: ChartToolTipProps | ChartToolTipPropsWithBody): ReactElement => {
  const displayTitle = title ?? (payload?.x ?? payload?.y)?.toString() ?? ''

  return (
    <TooltipContainer width={width} $maxWidth={maxWidth}>
      <TooltipContent>
        <TooltipTitle text={displayTitle} />
        <TooltipBody>
          {customBody ?? (
            <span>
              {header}: {value}
            </span>
          )}
        </TooltipBody>
      </TooltipContent>
    </TooltipContainer>
  )
}

const TooltipContainer = styled(Grid)<{ width: string; $maxWidth?: string }>(
  ({ theme, width, $maxWidth: maxWidth }) => ({
    backgroundColor: theme.tokens.background.main.inverse.default,
    width,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    maxWidth: maxWidth ?? 'none',
    wordBreak: 'break-word',
    zIndex: 1,
    color: theme.tokens.foreground.main.inverse,
    borderRadius: theme.borderRadius.xLarge
  })
)

const TooltipContent = styled(Grid)(() => ({
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: '16px',
  width: '100%'
}))

export default ChartToolTip
